import {
    PERSONA_STATUS_KEYS,
    PERSONA_STATUS_SHORT_LABELS,
} from './personaStatusLabels';

/**
 * @typedef {object} PersonaStatusBar
 * @property {string} name - Het aslabel (korte schrijfwijze)
 * @property {string} statusId - De sleutel zoals hij in Personas.Status staat
 * @property {{total: number}} value - Aantal deelnemers met die status
 */

/**
 * Tel deelnemers per status, in de vorm die de statusgrafieken lezen.
 *
 * Sleutels en volgorde komen uit de canonieke lijst; de korte schrijfwijze
 * omdat dit een grafiek-as voedt. `statusId` draagt de sleutel mee naast het
 * label, zodat de dashboardkaart op een staaf kan deeplinken.
 *
 * Elke bucket komt terug, ook met nul. Een deelnemer met een lege of onbekende
 * status telt nergens in mee — de grafiek toont de vier bekende statussen.
 *
 * Dit is de énige telling: de dashboardkaart en de live-report-widget hadden
 * hier tot 2026-09-09 allebei hun eigen identieke `reduce` voor.
 *
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {Array<{Status?: string}>} [personas] - Al gefilterde deelnemers
 * @returns {Array<PersonaStatusBar>}
 */
const countPersonasByStatus = (personas) => {
    const list = Array.isArray(personas) ? personas : [];

    const counts = list.reduce((acc, persona) => {
        const key = persona?.Status;
        if (key) acc[key] = (acc[key] || 0) + 1;
        return acc;
    }, {});

    return PERSONA_STATUS_KEYS.map((key) => ({
        name: PERSONA_STATUS_SHORT_LABELS[key],
        statusId: key,
        value: { total: counts[key] || 0 },
    }));
};

export default countPersonasByStatus;
